/**
 * RTWO Cryptography & Identity Engine — Ed25519 Key Provider
 */

import type { KeyProviderType } from '../adapters/key-provider-interface';
import { AlgorithmKeyProvider } from './algorithm-key-provider';

export class Ed25519KeyProvider extends AlgorithmKeyProvider {
  readonly providerId = 'ed25519-key-provider';
  readonly providerName = 'Ed25519 Key Provider';
  readonly providerType: KeyProviderType = 'ed25519';
  protected readonly supportedAlgorithm = 'Ed25519' as const;
  protected readonly supportedCurve = 'Ed25519' as const;
}
